import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"

import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

const KlarnaPlacementTypes = {
  mobile: "credit-promotion-badge",
  tablet: "credit-promotion-auto-size",
}

const KlarnaPlacementLeeFirori = ({ ...props }) => {
  return (
    <Box
      alignItems={{ _: "center" }}
      display={{ _: "flex" }}
      flexDirection={{ _: "column" }}
      {...props}
    >
      <klarna-placement
        data-key={KlarnaPlacementTypes.mobile}
        data-locale={props.locale}
        data-purchase-amount={props.priceToDisplay}
      ></klarna-placement>
    </Box>
  )
}

const KlarnaPlacementJewlr = ({ ...props }) => {
  const oppositeType = props.type === "tablet" ? "mobile" : "tablet"
  const defaultDisplay = props.type === "mobile" ? "flex" : "none"

  return (
    <Box
      alignItems={{ _: "center", tablet: "flex-end" }}
      display={{
        _: defaultDisplay,
        [oppositeType]: "none",
        [props.type]: "flex",
      }}
      flexDirection={{ _: "column" }}
      maxWidth={{ tablet: "250px" }}
      {...props}
    >
      <klarna-placement
        data-key={KlarnaPlacementTypes[props.type] || ""}
        data-locale={props.locale}
        data-purchase-amount={props.priceToDisplay}
      ></klarna-placement>
    </Box>
  )
}

const InternalKlarna = ({ pricing }) => {
  useEffect(() => {
    if (window.Klarna && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh()
    }
  }, [pricing])

  if (!enableKlarnaCheckout()) {
    return ""
  }

  const priceToDisplay = pricing.price_to_display * 100
  const locale = `en-${sl.config.site_country_for_analytics}`

  return (
    <>
      <KlarnaPlacementJewlr
        locale={locale}
        priceToDisplay={priceToDisplay}
        type="mobile"
      />
      <KlarnaPlacementJewlr
        locale={locale}
        priceToDisplay={priceToDisplay}
        type="tablet"
      />
    </>
  )
}

InternalKlarna.propTypes = {
  pricing: PropTypes.object,
}

KlarnaPlacementJewlr.propTypes = {
  locale: PropTypes.string,
  priceToDisplay: PropTypes.number,
  type: PropTypes.string,
}

KlarnaPlacementLeeFirori.propTypes = {
  locale: PropTypes.string,
  priceToDisplay: PropTypes.number,
}

const mapStateToProps = (state) => {
  return {
    pricing: state.wizardUI.currentPricing,
  }
}

const Klarna = connect(mapStateToProps)(InternalKlarna)

export default Klarna
